import React from "react";

function SideLog() {
  return (
    <>
      <span className="display-2">Buen</span>
      <span style={{ fontWeight: "500" }} className="display-2">
        Treino
      </span>
      <p className="d-flex display-6 pe-2 mt-5">
        El asistente para la administración y seguimiento de tus grupos de
        entrenamiento.{" "}
      </p>
    </>
  );
}

export default SideLog;
